import React from 'react'
import PropTypes from 'prop-types'
import { useAuth } from '../../Contexts/AuthContext'
import classes from './CookiePolicy.module.css'
import { cookiePolicy, cookiePolicyIntro } from '../../constants/cookiePolicy'

const renderList = list => (
  <ul className={classes.list}>
    {list.map((item, idx) => {
      if (typeof item === 'string') {
        return (
          <li
            className={classes.listItem}
            key={idx}
            dangerouslySetInnerHTML={{ __html: item }}
          />
        )
      }

      if (typeof item === 'object' && item !== null) {
        return (
          <li className={classes.listItem} key={idx}>
            <span dangerouslySetInnerHTML={{ __html: item.text }} />
            {item.subList &&
              Array.isArray(item.subList) &&
              renderList(item.subList)}
          </li>
        )
      }
      return null
    })}
  </ul>
)

const renderContactInfo = contactInfo => {
  if (!contactInfo || !Array.isArray(contactInfo.address)) return null

  return (
    <div className={classes.blockText}>
      <address>
        {contactInfo.address.map((line, idx) => (
          <div key={idx}>{line}</div>
        ))}
        {contactInfo.phone && (
          <div>
            Phone: <a href={`tel:${contactInfo.phone}`}>{contactInfo.phone}</a>
          </div>
        )}
      </address>
    </div>
  )
}

const renderParagraph = paragraph => {
  if (!paragraph) return null

  if (typeof paragraph === 'string') {
    let html = paragraph
    if (html.includes('<u>Withdrawing your consent:</u>')) {
      html = html.replace(
        '<u>Withdrawing your consent:</u>',
        '<u id="withdrawing-your-consent">Withdrawing your consent:</u>'
      )
    }
    return (
      <div
        className={classes.blockText}
        dangerouslySetInnerHTML={{ __html: html }}
      />
    )
  }

  if (paragraph.description && Array.isArray(paragraph.list)) {
    return (
      <div className={classes.blockText}>
        <div dangerouslySetInnerHTML={{ __html: paragraph.description }} />
        {renderList(paragraph.list)}
      </div>
    )
  }

  if (paragraph.description) {
    return (
      <div
        className={classes.blockText}
        dangerouslySetInnerHTML={{ __html: paragraph.description }}
      />
    )
  }

  if (paragraph.paragraphTitle && Array.isArray(paragraph.list)) {
    return (
      <div className={classes.blockText}>
        <div
          dangerouslySetInnerHTML={{ __html: paragraph.paragraphTitle }}
          id={paragraph.paragraphId}
        />
        {renderList(paragraph.list)}
      </div>
    )
  }

  if (paragraph.paragraphTitle) {
    return (
      <div
        className={classes.blockText}
        dangerouslySetInnerHTML={{ __html: paragraph.paragraphTitle }}
        id={paragraph.paragraphId}
      />
    )
  }

  if (Array.isArray(paragraph.list)) {
    return renderList(paragraph.list)
  }

  return Object.keys(paragraph).map(key => {
    if (
      typeof paragraph[key] === 'object' ||
      typeof paragraph[key] === 'string'
    ) {
      console.log(paragraph)

      return (
        <React.Fragment key={key}>
          {renderParagraph(paragraph[key])}
        </React.Fragment>
      )
    }
    return null
  })
}

const renderTable = tableData => (
  <table className={classes.table}>
    <thead>
      <tr>
        <th>Category</th>
        <th>Examples</th>
        <th>Collected</th>
      </tr>
    </thead>
    <tbody>
      {tableData.map((row, idx) => (
        <tr key={idx}>
          <td>{row.category}</td>
          <td>{row.examples}</td>
          <td>{row.collected ? 'YES' : 'NO'}</td>
        </tr>
      ))}
    </tbody>
  </table>
)

const CookiePolicyBlock = ({ id, title, content }) => (
  <div>
    <h1 className={classes.sectionTitle} id={`section-${id}`}>
      <span className={classes.titleId}>{id}.</span> {title}
    </h1>
    {Object.keys(content)
      .filter(key => key.toLowerCase().includes('paragraph'))
      .map(key => {
        console.log(content)
        return (
          <React.Fragment key={key}>
            {renderParagraph(content[key])}
            {content.contactInfo && renderContactInfo(content.contactInfo)}
          </React.Fragment>
        )
      })}
  </div>
)

const TableOfContents = () => (
  <div className={classes.tableOfContents}>
    <h2 className={classes.listTitle} id="table-of-contents">
      TABLE OF CONTENTS
    </h2>
    <div className={classes.columnsWrapper}>
      {[0, 9].map((start, idx) => (
        <ul className={classes.contentList} key={idx}>
          {cookiePolicy.slice(start, start + 9).map(item => (
            <li className={classes.contentListItem} key={item.id}>
              <a href={`#section-${item.id}`} className={classes.link}>
                <span className={classes.titleId}>{item.id}.</span> {item.title}
              </a>
            </li>
          ))}
        </ul>
      ))}
    </div>
  </div>
)

const CookiesPageTitles = () => (
  <div>
    {cookiePolicy.map(({ id, title, content }) => (
      <CookiePolicyBlock key={id} id={id} title={title} content={content} />
    ))}
  </div>
)

const CookiePolicy = () => {
  const { getCurrentUser } = useAuth()
  const containerClass = getCurrentUser()
    ? classes.authContainer
    : classes.container

  return (
    <div className={containerClass}>
      <div className={classes.wrapper}>
        <h1 className={classes.title}>{cookiePolicyIntro.title}</h1>
        <p className={classes.dateLabel}>
          Last updated {cookiePolicyIntro.lastUpdated}
        </p>
      </div>
      <div className={classes.intro}>
        <p
          dangerouslySetInnerHTML={{
            __html: cookiePolicyIntro.description,
          }}
        />
        <p
          dangerouslySetInnerHTML={{
            __html: cookiePolicyIntro.note,
          }}
        />
      </div>
      <TableOfContents />
      <CookiesPageTitles />
    </div>
  )
}

CookiePolicyBlock.propTypes = {
  id: PropTypes.number.isRequired,
  title: PropTypes.string.isRequired,
  content: PropTypes.object.isRequired,
}

export default CookiePolicy
